import { render, staticRenderFns } from "./AssistantApp.vue?vue&type=template&id=e946be3a&scoped=true&"
import script from "./AssistantApp.vue?vue&type=script&lang=js&"
export * from "./AssistantApp.vue?vue&type=script&lang=js&"
import style0 from "./AssistantApp.vue?vue&type=style&index=0&id=e946be3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e946be3a",
  null
  
)

export default component.exports